<template>
  <div class="row sp-px-24" v-if="galleries">
    <div v-for="(gallery, index) in galleries" :key="index" class="col-sm-12 mb-12" data-aos="fade-up">
      <div>
        <img v-lazy="gallery.image_url" />
      </div>
    </div>
    <div v-if="isLoading" class="col-sm-12 my-20 d-flex align-items-center justify-content-center height-80">
      <img src="/imgs/loading-png.gif" style="width: 100%; height: 100%; object-fit: contain;" />
    </div>
  </div>
</template>
 
<script>
  export default {
    props: ['paramGalleries', 'csrf', 'url'],
    data() {
      return {
        galleries: undefined,
        currentPage: 1,
        lastPage: 1,
        isLoading: true
      }
    },
    mounted() {
      const data = JSON.parse(this.paramGalleries)
      this.currentPage = data.current_page
      this.lastPage = data.last_page
      this.galleries = data.data
      window.addEventListener('scroll', this.handleScroll.bind(this));
      let self = this
      setTimeout(function() {
        self.isLoading = false
      }, 500)
    },
    methods: {
      handleScroll(event) {
        if (this.hasMore && ($(window).scrollTop() + $(window).height() >= $(document).height() - 100) && this.isLoading == false) {
          this.isLoading = true
          axios.post(this.url, {
            _token: this.csrf,
            page: this.currentPage + 1
          }).then(response => {
            if (response.data.galleries) {
              this.galleries = [...this.galleries, ...response.data.galleries.data]
              this.currentPage = response.data.galleries.current_page
              this.lastPage = response.data.galleries.last_page
            }
          }).finally(() => {
            console.log('here')
            this.isLoading = false
          })
        }
      }
    },
    computed: {
      hasMore() {
        return this.currentPage < this.lastPage
      }
    }
  }
</script>
